import React, { createContext, useCallback, useContext, useState } from 'react';
import { TenantSelector } from '@/components/tenant/TenantSelector';

interface TenantSwitchContextValue {
  openTenantSwitch: () => void;
}

const TenantSwitchContext = createContext<TenantSwitchContextValue | null>(null);

export function useTenantSwitch() {
  const ctx = useContext(TenantSwitchContext);
  return ctx;
}

export const TenantSwitchProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);

  const openTenantSwitch = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleTenantSelected = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <TenantSwitchContext.Provider value={{ openTenantSwitch }}>
      {children}
      <TenantSelector
        open={open}
        onClose={handleClose}
        onTenantSelected={handleTenantSelected}
      />
    </TenantSwitchContext.Provider>
  );
};
